import type { Status } from '../../utils/panorama/panoramaPeopleRows';
import type { RiskLevel } from '../../utils/panorama/panoramaDeadlineRisk';

export const PAGE_TITLE = 'Dashboard de férias';

export const ERROR_MESSAGE = 'Erro ao carregar dados. Tente novamente.';

export const CAPACITY_LIMIT_PERCENT = 15;

export const STAGE_LABELS: Record<string, string> = {
	manager: 'Gestor',
	client: 'Cliente',
	dp: 'DP',
	correction: 'Correção',
};

export const MONTH_LABELS = [
	'Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun',
	'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez',
];

export const CHART_COLORS = {
	primary: '#3d36be',
	secondary: '#9a96ee',
	bar: '#4840e0',
	alert: '#dc2626',
	grid: '#e2e8f0',
	axis: '#64748b',
};

export const RISK_LEVEL_ORDER: RiskLevel[] = ['expired', 'expiring', 'requested', 'scheduled', 'safe'];

export const RISK_LEVEL_META: Record<RiskLevel, { label: string; color: string; badge: string }> = {
	expired: { label: 'Vencidas', color: '#dc2626', badge: 'bg-red-50 text-red-700' },
	expiring: { label: 'Vencem em 90 dias, sem agendamento', color: '#f59e0b', badge: 'bg-amber-50 text-amber-700' },
	requested: { label: 'Pedido em andamento', color: '#9a96ee', badge: 'bg-primary-100 text-primary-700' },
	scheduled: { label: 'Agendadas', color: '#3d36be', badge: 'bg-primary-100 text-primary-800' },
	safe: { label: 'Em dia', color: '#059669', badge: 'bg-emerald-50 text-emerald-700' },
};

export const STATUS_ORDER: Status[] = ['acquiring', 'expired', 'approval-urgent', 'pending', 'expiring-soon', 'none', 'scheduled', 'on-vacation', 'taken'];

export const STATUS_META: Record<Status, { label: string; badge: string; dot: string; color: string }> = {
	'expired': { label: 'Férias vencidas', badge: 'bg-red-100 text-red-700', dot: 'bg-red-500', color: '#dc2626' },
	'on-vacation': { label: 'Em férias', badge: 'bg-teal-100 text-teal-700', dot: 'bg-teal-500', color: '#0d9488' },
	'scheduled': { label: 'Agendados', badge: 'bg-sky-100 text-sky-700', dot: 'bg-sky-500', color: '#0284c7' },
	'pending': { label: 'Em aprovação', badge: 'bg-violet-100 text-violet-700', dot: 'bg-violet-500', color: '#7c3aed' },
	'approval-urgent': { label: 'Aprovação urgente', badge: 'bg-orange-100 text-orange-700', dot: 'bg-orange-500', color: '#ea580c' },
	'expiring-soon': { label: 'Sem agendamento · vence em até 90 dias', badge: 'bg-amber-100 text-amber-800', dot: 'bg-amber-500', color: '#d97706' },
	'taken': { label: 'Férias usufruídas · últimos 30 dias', badge: 'bg-slate-100 text-slate-700', dot: 'bg-slate-400', color: '#64748b' },
	'none': { label: 'Sem agendamento · prazo distante', badge: 'bg-rose-100 text-rose-700', dot: 'bg-rose-500', color: '#db2777' },
	'acquiring': { label: 'Em aquisição', badge: 'bg-green-100 text-green-700', dot: 'bg-green-500', color: '#059669' },
};

export const DISPLAY_DATE_META: Record<string, { label: string; color: string }> = {
	'current': { label: 'Em férias', color: '#0d9488' },
	'scheduled': { label: 'Agendados', color: '#0284c7' },
	'request': { label: 'Período solicitado', color: '#7c3aed' },
	'request-approved': { label: 'Período aprovado', color: '#059669' },
	'request-rejected': { label: 'Período reprovado', color: '#6b7280' },
	'taken': { label: 'Usufruídas', color: '#64748b' },
	'approval-deadline': { label: 'Aprovar até', color: '#dc2626' },
	'deadline-passed': { label: 'Venceu em', color: '#dc2626' },
	'deadline': { label: 'Sair até', color: '#d97706' },
	'acquiring': { label: 'Adquire o direito em', color: '#059669' },
};

export const STATUS_OPTIONS = (STATUS_ORDER as Status[]).map(value => ({
	value,
	label: STATUS_META[value].label,
}));
